<!--
=========================================================================================
  File Name: FullPage.vue
  Description: Full page layout
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================
-->

<template>
  <div class="layout--full-page" >
    <keyboard-event></keyboard-event>
    <router-view></router-view>
  </div>
</template>
<style lang="scss">
#app .primary-text, .text-xs {
  color:rgb(var(--vs-primary)) !important;
}
#app .btn-primary {
  border-color: rgb(var(--vs-primary)) !important;
  background-color: rgb(var(--vs-primary)) !important;
}
.primary{
  border-color: rgb(var(--vs-primary)) !important;
  background-color: rgb(var(--vs-primary)) !important;
}
.border-primary{
  border-color: rgb(var(--vs-primary)) !important;
  color: rgb(var(--vs-primary)) !important;
}
.tab-selected{
  border-bottom-color: rgb(var(--vs-primary)) !important;
}
.btn-outline-primary{
  border-color: rgb(var(--vs-primary)) !important;
  color: rgb(var(--vs-primary)) !important;
}

.btn-outline-primary:hover{
  border-color: rgb(var(--vs-primary)) !important;
  color: #FFFFFF !important;
}
.nav-tabs .nav-link.active{
  color: rgb(var(--vs-primary)) !important;
}
.nav-tabs .nav-link:after{
  background: linear-gradient(30deg, rgb(var(--vs-primary)), rgba(var(--vs-primary))) !important;
}
.custom-checkbox .custom-control-label::before  {
  border-color: rgb(var(--vs-primary)) !important;
}
.custom-control-input:checked ~ .custom-control-label::before {
  border-color: rgb(var(--vs-primary)) !important;
  background-color: rgb(var(--vs-primary)) !important;
}
.btn-primary:focus, .btn-primary:active, .btn-primary.active{
  background-color: rgb(var(--vs-primary)) !important;
}
</style>
<script>
import KeyboardEvent from '@/febos/global/_vue/componentes/devOpHelpers/DeveloperMode';
import I18nMixin from '@/febos/global/_vue/mixins/I18nMixin';
import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';

export default {
  components: { KeyboardEvent },
  mixins: [I18nMixin, PersonalizacionMixin]
};
</script>
